import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';

import { ModalFrame, ModalFrameFooter, ModalFrameInner } from 'components/modal';

import { __t, applyTranslations } from 'utils/language';

import './ccm-campaign-brief-modal.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./ccm-campaign-brief-modal.i18n.json'));

type Props = {
  onCloseModal: () => void
};

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'ccm_campaign_brief_modal';

const CcmCampaignBriefModal: React.FC<Props> = ({
  onCloseModal
}): JSX.Element => {
  const renderExample = (
    key: 'one' | 'two' | 'three'
  ): React.ReactNode => (
    <div className="ccm-campaign-brief-modal__example">
      <div className="ccm-campaign-brief-modal__example-title">
        {__t(`${MSG_KEY}.examples.${key}.title`)}
      </div>
      <div className="ccm-campaign-brief-modal__example-text">
        {__t(`${MSG_KEY}.examples.${key}.text`)}
      </div>
    </div>
  );

  return (
    <div className="ccm-campaign-brief-modal">
      <ModalFrame
        classNameFrame="ccm-campaign-brief-modal__frame"
      >
        <ModalFrameInner
          className="ccm-campaign-brief-modal__inner"
        >
          <div className="ccm-campaign-brief-modal__title">
            {__t(`${MSG_KEY}.title`)}
          </div>
          <div className="ccm-campaign-brief-modal__subtitle">
            {__t(`${MSG_KEY}.subtitle`)}
          </div>
          <div className="ccm-campaign-brief-modal__examples">
            {renderExample('one')}
            {renderExample('two')}
            {renderExample('three')}
          </div>
        </ModalFrameInner>
        <ModalFrameFooter>
          <ActionButton
            color="secondary"
            onClick={onCloseModal}
          >
            {__t(`${COMMON_MSG_KEY}.action_button.close`)}
          </ActionButton>
        </ModalFrameFooter>
      </ModalFrame>
    </div>
  );
};

export default CcmCampaignBriefModal;
